<template>
  <div id="head" class="head">
    <div class="head-left" @click="goBack">
      <a class="hym-head-left"></a>
    </div>
    <div class="head-title">{{ vuetiltle }}</div>
    <div class="head-right"></div>
  </div>
</template>
<script>
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
//接口地址
import api from "../../api/index";
import tips from "@/estoast";

export default {
  name: "head-back",
  data() {
    return {
      vuetiltle: this.title
    };
  },
  props: {
    title: String,
    url: String
  },
  methods: {
    closeviwe:function(){
      window.location.href = "hqml://closeWindow";
    },
    goBack: function() {
      if (this.url == "" || this.url == null) {
        store.commit(types.SET_LOGIN_OBJ, null);
        this.$router.go(-1);
      } else {
        this.$router.push(this.url);
      }
    }
  }
};
</script>
<style scoped>
.head {
  left: 0;
  width: 100%;
  height: 88px;
  height: calc(88px + constant(safe-area-inset-top));
  height: calc(88px + env(safe-area-inset-top));
  padding: 7px 3px;
  padding-top: calc(7px + constant(safe-area-inset-top));
  padding-top: calc(7px + env(safe-area-inset-top));
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  overflow: hidden;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  box-sizing: border-box;
  z-index: 998;
  color: #000000;
  background-color: #fff;
  -webkit-transition-property: all;
  transition-property: all;
}
.head-left {
  position: relative;
  width: 18px;
  height: 32px;
  margin: 30px 0px 28px 32px;
  word-break: keep-all;
  white-space: pre;
  background: url("../../assets/img/head-back-app@2x.png");
  background-size: 100% 100%;
}
.head-left img {
  width: 18;
  height: 32px;
  float: left;
}

.head-title {
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: #fff;
  margin: 18px 0px 20px 0px;
  width: 252px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 50px;
}

.head-right {
  position: relative;
  width: auto;
  margin: 5px 13px 14px 16px;
  word-break: keep-all;
  white-space: pre;
  float: right;
  width: 48px;
  height: 34px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 34px;
  margin: 22px 32px 32px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/head-back-app.vue